import { Component, Optional, Self, Input } from '@angular/core';
import { NgControl } from '@angular/forms';
import { CorpControlCommonComponent } from '../../common/corp-control-common/corp-control-common.component';
import { CorpControlTitleComponent } from '../../common/corp-control-title/corp-control-title.component';
import { CorpSpinnerComponent } from '@corporate-tailwind/component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'corp-input-mask',
  templateUrl: './corp-input-mask.component.html',
  imports: [CommonModule, CorpControlTitleComponent, CorpSpinnerComponent]
})
export class CorpInputMaskComponent extends CorpControlCommonComponent {

  @Input('corp-mask') mask: string = '';

  constructor(@Optional() @Self() public override ngControl: NgControl) {
    super();
    this.setNgControl(ngControl);
  }

  override onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    let val = input.value;

    if (this.mask) {
      val = this.applyMask(val);
    }

    this.value = val;
    input.value = val; // 🔥 IMPORTANT

    this.onChange(val);
  }

  private applyMask(value: string): string {
    const clean = value.replace(/[^a-zA-Z0-9]/g, '');
    let result = '';
    let vi = 0;

    for (let mi = 0; mi < this.mask.length; mi++) {
      const m = this.mask[mi];
      const v = clean[vi];

      if (!v) break;

      if (m === '0') {
        if (/\d/.test(v)) {
          result += v;
          vi++;
        } else {
          vi++;
          mi--; // retry même position mask
        }
      }
      else if (m === 'X') {
        if (/[a-zA-Z]/.test(v)) {
          result += v.toUpperCase();
          vi++;
        } else {
          vi++;
          mi--;
        }
      }
      else if (m === '*') {
        result += v;
        vi++;
      }
      else {
        result += m;
      }
    }

    return result;
  }
}